import { useState } from 'react';
import type { Book } from '../lib/api/types';
import { isWebGLAvailable } from './explorerStore';
import { AtlasScene3D } from './AtlasScene3D';
import { AtlasView2D } from './AtlasView2D';

interface AtlasViewProps {
  books: Book[];
  onSelect: (slug: string) => void;
}

/**
 * Atlas 星图入口：GPU 可用时渲染 3D 星图，否则降级为 2D SVG 星图。
 */
export function AtlasView({ books, onSelect }: AtlasViewProps) {
  // 惰性探测一次：沙箱 GPU 禁用 → 2D；真机 → 3D
  const [webgl] = useState(() => isWebGLAvailable());
  if (webgl) {
    return <AtlasScene3D books={books} onSelect={onSelect} />;
  }
  return <AtlasView2D books={books} onSelect={onSelect} />;
}